import React from 'react';
import { useTranslation } from 'react-i18next';
import { ComponentInstanceIcon } from '@radix-ui/react-icons';
import { translatePropertyChipLabel } from '@/shared/utils/property-chip-label';
import type { PropertyFilters } from './constants';
import {
  AMENITIES_INTERNAL_OPTIONS,
  AMENITIES_EXTERNAL_OPTIONS,
  AMENITIES_SECURITY_OPTIONS,
} from './constants';
import { SectionHeader, FieldLabel, ChipBtn } from './parts';

interface Props {
  filters: PropertyFilters;
  toggleInArray: (field: keyof PropertyFilters, value: string) => void;
}

/**
 * Checks whether an array-valued filter field already includes a value.
 */
const has = (filters: PropertyFilters, field: keyof PropertyFilters, value: string) =>
  ((filters[field] as string[] | undefined) || []).includes(value);

export const FilterSectionAmenities: React.FC<Props> = ({ filters, toggleInArray }) => {
  const { t } = useTranslation('features/properties');
  return (
    <div>
      <SectionHeader icon={<ComponentInstanceIcon width={14} height={14} />} title={t('filterPanel.amenities')} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
        <div>
          <FieldLabel>{t('filterPanel.amenitiesInternal')}</FieldLabel>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-1)' }}>
            {AMENITIES_INTERNAL_OPTIONS.map((token) => (
              <ChipBtn key={token} value={translatePropertyChipLabel(t, token)} active={has(filters, 'amenitiesInternal', token)} onClick={() => toggleInArray('amenitiesInternal', token)} />
            ))}
          </div>
        </div>
        <div>
          <FieldLabel>{t('filterPanel.amenitiesExternal')}</FieldLabel>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-1)' }}>
            {AMENITIES_EXTERNAL_OPTIONS.map((token) => (
              <ChipBtn key={token} value={translatePropertyChipLabel(t, token)} active={has(filters, 'amenitiesExternal', token)} onClick={() => toggleInArray('amenitiesExternal', token)} />
            ))}
          </div>
        </div>
        <div>
          <FieldLabel>{t('filterPanel.amenitiesSecurity')}</FieldLabel>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-1)' }}>
            {AMENITIES_SECURITY_OPTIONS.map((token) => (
              <ChipBtn key={token} value={translatePropertyChipLabel(t, token)} active={has(filters, 'amenitiesSecurity', token)} onClick={() => toggleInArray('amenitiesSecurity', token)} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
